import ScrollContainer from "react-indiana-drag-scroll";
export default ScrollContainer;
